import { Button, BUTTON_THEME, Icon } from '@st-operations/uikit/src/v2'
import React, { useMemo, useState, useEffect } from 'react'
import CheckboxTree from 'react-checkbox-tree'

import ColoredCheckbox from '_components/colored-checkbox'
import useCategoryUsers from '../hooks/useCategoryUsers'
import useTotalUsers from '../hooks/useTotalUsers'
import MonthlyUserCount from '../monthly-user-count'
import extractCategoryTree from '../../categories/extractCategoryTree'

import './styles.scss'

const EventFeedsWizardCategories = ({
  onSkip,
  onBackClick,
  checked,
  onCheckedChange,
  onAddCategories,
  cumulativeFilters,
  onCumulativeFiltersChange,
}) => {
  const [expanded, setExpanded] = useState([])

  const payload = useMemo(() => {
    const withoutCategories = cumulativeFilters.filter((f) => f.key !== 'categories')
    return checked?.length > 0
      ? {
          filters: [...withoutCategories, { key: 'categories', operator: 'in', value: checked }],
        }
      : { filters: [...withoutCategories] }
  }, [checked])
  const [categoryUsers] = useCategoryUsers(payload)
  const [totalUsers] = useTotalUsers(payload)

  useEffect(() => {
    if (onCumulativeFiltersChange) {
      onCumulativeFiltersChange(payload.filters)
    }
  }, [payload])

  return (
    <div className="event-feeds-wizard-categories__container">
      <Button
        theme={BUTTON_THEME.GHOST}
        onClick={onBackClick}
        className="event-feeds-wizard-categories__back-button"
      >
        <Icon type="outline" icon="angleleft" />
        Back
      </Button>
      <span className="event-feeds-wizard-categories__title">{`3. I'm interested in these categories:`}</span>
      <div className="event-feeds-wizard-categories__tree-container">
        <CheckboxTree
          nodes={extractCategoryTree(categoryUsers?.categories || [])}
          checked={checked}
          expanded={expanded}
          showNodeIcon={false}
          optimisticToggle={true}
          noCascade
          onCheck={(checked) => onCheckedChange(checked)}
          onExpand={(expanded) => setExpanded(expanded)}
          icons={{
            expandClose: (
              <Icon
                type="outline"
                icon="angledown"
                className="event-feeds-wizard-categories__tree-checkbox"
                width={24}
                height={24}
                color="#3D3D3D"
              />
            ),
            expandOpen: (
              <Icon
                type="outline"
                className="event-feeds-wizard-categories__tree-checkbox"
                icon="angleright"
                width={24}
                height={24}
              />
            ),
            halfCheck: <ColoredCheckbox className="event-feeds-wizard-categories__tree-checkbox" />,
            check: (
              <ColoredCheckbox className="event-feeds-wizard-categories__tree-checkbox" checked />
            ),
            uncheck: <ColoredCheckbox className="event-feeds-wizard-categories__tree-checkbox" />,
          }}
        />
      </div>
      <MonthlyUserCount totalUsers={totalUsers} />
      <Button theme={BUTTON_THEME.GHOST} onClick={onSkip}>
        Skip
      </Button>
      <div className="event-feeds-wizard-categories__add-terms-container">
        <Button
          className="event-feeds-wizard-categories__add-terms-button"
          disabled={checked.length === 0}
          onClick={onAddCategories}
        >
          Add Categories
        </Button>
      </div>
    </div>
  )
}

export default EventFeedsWizardCategories
